import React, { createContext, useContext, useState } from "react";
import { suggestedFolder } from "../types/following";

type FilingContextType = {
  suggestedFolders: suggestedFolder[];
  setSuggestedFolders: (folders: suggestedFolder[]) => void;
  lastFiledFolder: suggestedFolder | null;
  setLastFiledFolder: (folder: suggestedFolder | null) => void;
};

const FilingContext = createContext<FilingContextType>({
  suggestedFolders: [],
  setSuggestedFolders: () => {},
  lastFiledFolder: null,
  setLastFiledFolder: () => {},
});

export const FilingContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [suggestedFolders, setSuggestedFolders] = useState<suggestedFolder[]>([]);
  const [lastFiledFolder, setLastFiledFolder] = useState<suggestedFolder | null>(null);

  return (
    <FilingContext.Provider value={{ suggestedFolders, setSuggestedFolders, lastFiledFolder, setLastFiledFolder }}>
      {children}
    </FilingContext.Provider>
  );
};

export const useFilingContext = () => useContext(FilingContext);

export default FilingContext;
